
// import { useEffect, useState } from "react";
// import Swal from "sweetalert2";

// const SampleModel = ({ item, onUpNow }) => {
//     const [formData, setFormData] = useState({
//         id: "",
//         sample_type: "",
//         sample_qty: "",
//         cont_type: "Tube",
//         sample_cndi: "Frozen",
//         alertMsgTyp: '',
//         isAlert: false,
//     });



//     const handleChange = (e) => {

//         const { name, value } = e.target;
//         setFormData(prev => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     useEffect(() => {
//         if (item) {
//             // alert(item.lab_paid+"");
//             setFormData(prev => ({
//                 ...prev,
//                 id: item.lab_reg_id || "",
//                 sample_type: item.sample_type || "",
//                 sample_qty: item.sample_qty || "",
//                 cont_type: item.cont_type || "",
//                 sample_cndi: item.sample_cndi || "",

//             }));
//         }
//     }, [item]);



//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         onUpNow(
//             formData.id,
//             formData.sample_type,
//             formData.sample_qty,
//             formData.cont_type,
//             formData.sample_cndi,
//         );

//     };



//     return (
//         <div class="modal fade" id="showModal1" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
//             <div class="modal-dialog modal-dialog-centered">
//                 <div class="modal-content">
//                     <div class="modal-header bg-light p-3">
//                         <h5 class="modal-title" id="exampleModalLabel">&nbsp;</h5>
//                         <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"></button>
//                     </div>
//                     <form class="tablelist-form" onSubmit={handleSubmit}>
//                         <div class="modal-body">
//                             <input id="id-field" type="hidden" />
//                             <div class="row gy-4 mb-3">

//                                 <div class="col-md-6">
//                                     <div class="mb-3">
//                                         <label for="firstNameinput" class="form-label">Sample Type</label>
//                                     <select class="form-control" name="sample_type" 
//                                     onChange={handleChange} value={formData.sample_type} required>
//                                         <option value="Blood">Blood</option>
//                                         <option value="Urine">Urine</option>
//                                         <option value="Saliva">Saliva</option>
//                                         <option value="Swab">Swab</option>
//                                         <option value="Biopsy">Biopsy</option>
//                                     </select>
                                    
//                                     </div>
//                                 </div>
//                                 <div class="col-md-6">
//                                     <div class="mb-3">
//                                         <label for="firstNameinput" class="form-label">Qty</label>
//                                         <input type="number" class="form-control" placeholder="Enter Qty"
//                                             name="sample_qty" onChange={handleChange} value={formData.sample_qty}  />
//                                     </div>
//                                 </div>
//                                 <div class="col-md-6">
//                                     <div class="mb-3">
//                                         <label for="firstNameinput" class="form-label">Container Type</label>
//                                          <select class="form-control" name="cont_type" 
//                                     onChange={handleChange} value={formData.cont_type} required>
//                                         <option value="Tube">Tube</option>
//                                         <option value="Jar">Jar</option>
//                                         <option value="Other">Other</option>
//                                     </select>
//                                     </div>
//                                 </div>
//                                 <div class="col-md-6">
//                                     <div class="mb-3">
//                                         <label for="firstNameinput" class="form-label">Final Sample Condition</label>
//                                     <select class="form-control" name="sample_cndi" 
//                                     onChange={handleChange} value={formData.sample_cndi} required>
//                                         <option value="Frozen">Frozen</option>
//                                         <option value="Room Temp">Room Temp</option>
//                                         <option value="Other">Other</option>
//                                     </select>
//                                     </div>
//                                 </div>

//                             </div>
//                         </div>
//                         <div class="modal-footer">
//                             <div class="hstack gap-2 justify-content-end">
//                                 <button type="button" id="dfgdfvnew" class="btn btn-light" data-bs-dismiss="modal">Close</button>
//                                 <button type="submit" class="btn btn-success" id="edit-btn">Collect</button>
//                             </div>
//                         </div>

//                     </form>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default SampleModel;


// SampleModel.jsx
// import React, { useEffect, useRef, useState } from "react";
// import JsBarcode from "jsbarcode";
// import { Modal, Button, Form } from "react-bootstrap";

// const SampleModel = ({ item, onUpNow, onClose }) => {
//   const [selectedTest, setSelectedTest] = useState(null);
//   const [sampleType, setSampleType] = useState("");
//   const [sampleQty, setSampleQty] = useState(1);
//   const [contType, setContType] = useState("");
//   const [sampleCndi, setSampleCndi] = useState("");
//   const svgRef = useRef(null);

//   const tests = Array.isArray(item?.params) ? item.params : (item?.all_tests || []);

//   useEffect(() => {
//     setSelectedTest(tests.length ? tests[0] : null);
//     setSampleType("");
//     setSampleQty(1);
//     setContType("");
//     setSampleCndi("");
//   }, [item]);

//   useEffect(() => {
//     if (!svgRef.current) return;
//     const uhId = item?.lab_reg_uhid || "";
//     const payload = selectedTest ? `${uhId}_${selectedTest.lab_item_test_id || selectedTest.lab_item_test_name}` : uhId;
//     try {
//       svgRef.current.innerHTML = "";
//       const tempSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
//       svgRef.current.appendChild(tempSvg);
//       JsBarcode(tempSvg, payload, {
//         format: "CODE128",
//         displayValue: true,
//         fontSize: 12,
//         height: 40,
//         margin: 6
//       });
//     } catch (err) {
//       console.error("Barcode render failed", err);
//     }
//   }, [item, selectedTest]);

//   const handleConfirm = async () => {
//     if (!item) return;
//     await onUpNow(item.lab_reg_id, sampleType, sampleQty, contType, sampleCndi);
//     // close via parent prop
//     if (onClose) onClose();
//   };

//   const handlePrintBarcode = () => {
//     const svgElement = svgRef.current?.querySelector("svg");
//     if (!svgElement) return;
//     const svgData = new XMLSerializer().serializeToString(svgElement);
//     const html = `<html><head><title>Barcode</title></head><body style="display:flex;justify-content:center;align-items:center;height:100vh;">${svgData}</body></html>`;
//     const w = window.open("", "_blank");
//     if (!w) return;
//     w.document.open();
//     w.document.write(html);
//     w.document.close();
//     setTimeout(() => { w.print(); }, 300);
//   };

//   return (
//     <Modal show={!!item} onHide={onClose} size="lg" centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Collect Sample - {item?.lab_reg_name || "Patient"}</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <div><strong>UHID:</strong> {item?.lab_reg_uhid} &nbsp; <strong>Reg No:</strong> {item?.lab_reg_id}</div>
//         <hr />
//         <div><h6>Tests</h6>
//           {tests.length ? tests.map((t, i) => (
//             <Form.Check key={i} type="radio" name="sampleTest"
//               label={t.lab_item_test_name || t.test_name || "Unnamed Test"}
//               checked={selectedTest === t}
//               onChange={() => setSelectedTest(t)} />
//           )) : <div>No tests available</div>}
//         </div>

//         <hr />
//         <div className="row g-2">
//           <div className="col-md-4"><label>Sample Type</label><input className="form-control" value={sampleType} onChange={e=>setSampleType(e.target.value)} /></div>
//           <div className="col-md-2"><label>Qty</label><input type="number" className="form-control" value={sampleQty} min={1} onChange={e=>setSampleQty(e.target.value)} /></div>
//           <div className="col-md-3"><label>Container Type</label><input className="form-control" value={contType} onChange={e=>setContType(e.target.value)} /></div>
//           <div className="col-md-3"><label>Condition</label><input className="form-control" value={sampleCndi} onChange={e=>setSampleCndi(e.target.value)} /></div>
//         </div>

//         <hr />
//         <div style={{display:"flex",alignItems:"center",gap:20}}>
//           <div ref={svgRef} aria-hidden="true"/>
//           <div>
//             <div><strong>Barcode</strong></div>
//             <div style={{marginTop:8}}><Button variant="secondary" size="sm" onClick={handlePrintBarcode}>Print Barcode</Button></div>
//           </div>
//         </div>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={onClose}>Cancel</Button>
//         <Button variant="primary" onClick={handleConfirm}>Collected</Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

// export default SampleModel;

import React, { useEffect, useRef, useState } from "react";
import JsBarcode from "jsbarcode";
import { Modal, Button, Form } from "react-bootstrap";

/**
 * SampleModel
 * - Defaults: all tests checked
 * - On Print: creates a thermal-friendly print window (58mm or 80mm)
 * - Each label: Top => test name (hidden for radiology), Middle => Barcode (UHID only), Bottom => UHID text + dimension display (W/H)
 * - Controls: choose thermal width preset, adjust bar width and barcode height (mm)
 */
const SampleModel = ({ item, onUpNow, onClose, show }) => {
  const tests = Array.isArray(item?.params) ? item.params : (item?.all_tests || []);
  const [selectedTests, setSelectedTests] = useState([]);
  const [sampleType, setSampleType] = useState("");
  const [sampleQty, setSampleQty] = useState(1);
  const [contType, setContType] = useState("");
  const [sampleCndi, setSampleCndi] = useState("");

  // Thermal settings
  const [paperWidthMm, setPaperWidthMm] = useState(58); // 58mm default (common)
  const [barWidth, setBarWidth] = useState(1); // JsBarcode 'width' option (bar thickness)
  const [barcodeHeightMm, setBarcodeHeightMm] = useState(12); // desired barcode height in mm (default 12mm)

  const svgRef = useRef(null);

  useEffect(() => {
    // default select ALL tests
    if (tests && tests.length) {
      setSelectedTests(tests.slice()); // copy all
    } else {
      setSelectedTests([]);
    }

    // reset sample fields
    setSampleType("");
    setSampleQty(1);
    setContType("");
    setSampleCndi("");
  }, [item]);

  // Radiology detection heuristics (keeps previous logic)
  const isRadiologyTest = (t) => {
    if (!t) return false;
    if (t.test_cat === 60 || t.test_cat === "60" || t.lab_item_test_cat === 60) return true;
    if (String(t.dept_name || "").toLowerCase().includes("radiology")) return true;
    if (String(t.lab_item_test_name || t.test_name || "").toLowerCase().includes("radiology")) return true;
    return false;
  };

  // toggle selection
  const toggleTestSelection = (test) => {
    const key = (test.lab_item_test_id || test.lab_item_test_name || test.test_id || test.test_name).toString();
    setSelectedTests(prev => {
      const found = prev.some(t => (t.lab_item_test_id || t.lab_item_test_name || t.test_id || t.test_name) === (test.lab_item_test_id || test.lab_item_test_name || test.test_id || test.test_name));
      if (found) return prev.filter(t => (t.lab_item_test_id || t.lab_item_test_name || t.test_id || t.test_name) !== (test.lab_item_test_id || test.lab_item_test_name || test.test_id || test.test_name));
      return [...prev, test];
    });
  };

  // Build preview in modal (non-print) showing barcodes rendered in DOM (optional)
  useEffect(() => {
    if (!svgRef.current) return;
    svgRef.current.innerHTML = "";
    try {
      const uhId = item?.lab_reg_uhid || "";
      const mmToPx = (mm) => {
        // 1in = 25.4mm. Browsers render ~96 DPI by default => 96 px/inch
        // px = (mm / 25.4) * 96. This is for on-screen preview only.
        return (mm / 25.4) * 96;
      };
      const heightPx = Math.max(10, mmToPx(barcodeHeightMm)); // ensure not zero

      const renderOne = (test) => {
        const wrapper = document.createElement("div");
        wrapper.style.display = "inline-block";
        wrapper.style.width = "auto";
        wrapper.style.margin = "6px";
        wrapper.style.padding = "6px";
        wrapper.style.textAlign = "center";
        wrapper.style.border = "1px dashed #ddd";
        wrapper.style.background = "#fff";

        // Top: name (unless radiology)
        // const name = isRadiologyTest(test) ? "" : (test.lab_item_test_name || test.test_name || "");
        // if (name) {
        //   const nameDiv = document.createElement("div");
        //   nameDiv.textContent = name;
        //   nameDiv.style.fontSize = "12px";
        //   nameDiv.style.marginBottom = "6px";
        //   wrapper.appendChild(nameDiv);
        // }
// Top: patient name (always)
const name = item?.lab_reg_name || "";
if (name) {
  const nameDiv = document.createElement("div");
  nameDiv.textContent = name;
  nameDiv.style.fontSize = "12px";
  nameDiv.style.marginBottom = "6px";
  wrapper.appendChild(nameDiv);
}

        // SVG container
        const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
        svg.style.display = "block";
        svg.style.margin = "0 auto";
        // create a small text label under barcode for display (uhid)
        wrapper.appendChild(svg);

        // UHID only for payload
        const payload = uhId;

        // generate barcode
        JsBarcode(svg, payload, {
          format: "CODE128",
          width: Number(barWidth),
          height: Number(heightPx),
          displayValue: false, // hide built-in text because we will add UHID text under it separately
          margin: 6,
        });

        // UHID text under barcode
        const txt = document.createElement("div");
        txt.textContent = payload;
        txt.style.fontSize = "11px";
        txt.style.marginTop = "4px";
        wrapper.appendChild(txt);

        const dim = document.createElement("div");
        dim.style.fontSize = "10px";
        dim.style.color = "#666";
        dim.style.marginTop = "4px";
        // show configured dimensions for user's information
        //dim.textContent = `W(bar width): ${barWidth} px | H: ${barcodeHeightMm} mm`;
        wrapper.appendChild(dim);

        svgRef.current.appendChild(wrapper);
      };

      if (selectedTests && selectedTests.length) {
        selectedTests.forEach(t => renderOne(t));
      } else {
        // fallback single label for UHID
        renderOne({ lab_item_test_name: "Label", test_name: "Label" });
      }
    } catch (err) {
      console.error("Error rendering preview barcodes:", err);
    }
  }, [selectedTests, barWidth, barcodeHeightMm, item]);

  const handleConfirm = async () => {
    if (!item) return;
    await onUpNow(item.lab_reg_id, sampleType, sampleQty, contType, sampleCndi);
    if (onClose) onClose();
  };

  // Build thermal print HTML and open print window
  const handlePrintBarcode = () => {
    const uhId = item?.lab_reg_uhid || "";
    if (!uhId) {
      alert("UHID missing — cannot print barcode.");
      return;
    }
    if (!selectedTests || selectedTests.length === 0) {
      alert("Please select at least one test.");
      return;
    }
    const patientName = item?.lab_reg_name || "";
    // Convert mm to px for inline SVG sizing in printed HTML.
    // Printing from browser: we will set @page size in mm, but for SVG height/width we need px.
    // We'll use 96 DPI fallback for screen-to-print mapping; thermal printer DPI differs but this gives reasonable preview.
    const mmToPx = (mm) => (mm / 25.4) * 96;
    const barcodeHeightPx = mmToPx(barcodeHeightMm);

    // Build labels HTML
    const labelHtmlParts = selectedTests.map(test => {
        return `
          <div class="label">
            <div class="name">${escapeHtml(patientName)}</div>
            <div class="svg-wrap" data-payload="${escapeHtml(uhId)}" data-width="${barWidth}" data-height="${barcodeHeightPx}"></div>
            <div class="uhid-text">${escapeHtml(uhId)}</div>
           
          </div>
        `;
      }).join("");

    // CSS: set page width based on chosen paperWidthMm and style labels for thermal
    const css = `
      <style>
        @page { size: ${paperWidthMm}mm auto; margin: 2mm; }
        body { margin:0; padding:4mm; font-family: Arial, Helvetica, sans-serif; background: #fff; }
        .labels { width: ${paperWidthMm}mm; display:block; }
        .label { width: ${paperWidthMm - 4}mm; /* allow small margin */ display:block; padding:4px 2px; box-sizing:border-box; page-break-inside:avoid; margin-bottom:6px; border-bottom: 0.5px dashed #ccc; text-align:left;}
        .label .name { font-size: 12px; font-weight:700; margin-bottom:4px; text-transform: uppercase; }
        .label .svg-wrap { width: 100%; display:flex; justify-content:flex-start; align-items:center; margin-bottom:4px; }
        .label svg { max-width:100%; height: auto; display:block; }
        .label .uhid-text { font-size: 11px; margin-top:2px;}
        .label .dims { font-size: 10px; color:#666; margin-top:4px; }
      </style>
    `;

    // Build the HTML that will render barcodes with JsBarcode in the new window.
    const html = `
      <html>
      <head>
        <meta charset="utf-8" />
        <title>Print Barcodes</title>
        ${css}
        <!-- JsBarcode CDN (inline) -->
        <script src="https://cdn.jsdelivr.net/npm/jsbarcode@3.11.5/dist/JsBarcode.all.min.js"></script>
      </head>
      <body>
        <div class="labels">
          ${labelHtmlParts}
        </div>

        <script>
          (function(){
            // On load, find each svg-wrap and create an SVG element then render JsBarcode
            document.querySelectorAll('.svg-wrap').forEach(function(el){
              var payload = el.getAttribute('data-payload') || '';
              var w = Number(el.getAttribute('data-width')) || 1;
              var heightPx = Number(el.getAttribute('data-height')) || 48;
              // create svg
              var svgNS = "http://www.w3.org/2000/svg";
              var svg = document.createElementNS(svgNS, "svg");
              // set some default width so barcode scales to left side (we can set height)
              svg.setAttribute('width', '100%');
              svg.setAttribute('height', heightPx + '');
              el.appendChild(svg);
              try {
                JsBarcode(svg, payload, {
                  format: "CODE128",
                  displayValue: false,
                  width: w,
                  height: heightPx,
                  margin: 2
                });
              } catch(e) {
                console.error('Barcode render failed', e);
              }
            });

            // Small timeout then trigger print
            setTimeout(function(){
              window.print();
            }, 350);
          })();
        </script>
      </body>
      </html>
    `;

    const w = window.open("", "_blank");
    if (!w) {
      alert("Popup blocked. Please allow popups for this site.");
      return;
    }
    w.document.open();
    w.document.write(html);
    w.document.close();
  };

  // simple escape for HTML attributes/content
  const escapeHtml = (s) => {
    if (!s && s !== 0) return "";
    return String(s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  };

  return (
    <Modal show={!!item || !!show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Collect Sample - {item?.lab_reg_name || "Patient"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <strong>UHID:</strong> {item?.lab_reg_uhid} &nbsp; <strong>Reg No:</strong> {item?.lab_reg_id}
        </div>
        <hr />
        <div>
          <h6>Tests (default: all selected)</h6>
          {tests.length ? (
            <div style={{ maxHeight: 220, overflowY: "auto", paddingRight: 6 }}>
              {tests.map((t, i) => {
                const idKey = (t.lab_item_test_id || t.lab_item_test_name || `t-${i}`).toString();
                const checked = selectedTests.some(s => (s.lab_item_test_id || s.lab_item_test_name || s.test_id || s.test_name) === (t.lab_item_test_id || t.lab_item_test_name || t.test_id || t.test_name));
                return (
                  <Form.Check
                    key={idKey}
                    type="checkbox"
                    id={`test_chk_${idKey}`}
                    label={`${t.lab_item_test_name || t.test_name || "Unnamed Test"}${isRadiologyTest(t) ? " (Radiology)" : ""}`}
                    checked={checked}
                    onChange={() => toggleTestSelection(t)}
                  />
                );
              })}
            </div>
          ) : <div>No tests available</div>}
        </div>

        <hr />
        <div className="row g-2">
          <div className="col-md-4">
            <label>Thermal Paper Width</label>
            <select className="form-control" value={paperWidthMm} onChange={(e) => setPaperWidthMm(Number(e.target.value))}>
              <option value={58}>58 mm (common)</option>
              <option value={80}>80 mm (common)</option>
            </select>
          </div>
          <div className="col-md-4">
            <label>Bar Width (JsBarcode width, px)</label>
            <input type="number" className="form-control" value={barWidth} min={0.2} step={0.1} onChange={(e) => setBarWidth(e.target.value)} />
            <small className="text-muted">Smaller = narrower bars</small>
          </div>
          <div className="col-md-4">
            <label>Barcode Height (mm)</label>
            <input type="number" className="form-control" value={barcodeHeightMm} min={6} step={1} onChange={(e) => setBarcodeHeightMm(Number(e.target.value))} />
            <small className="text-muted">Height shown under barcode too</small>
          </div>
          {/* <div className="col-md-3">
            <label>Qty</label>
            <input type="number" className="form-control" value={sampleQty} min={1} onChange={e => setSampleQty(e.target.value)} />
          </div> */}
        </div>

        <hr />
        <div style={{ display: "flex", alignItems: "flex-start", gap: 20 }}>
          <div ref={svgRef} aria-hidden="true" style={{ flex: 1, background: "#f9f9f9", padding: 8, borderRadius: 4 }} />
          <div style={{ minWidth: 220 }}>
            <div><strong>Barcode Preview</strong></div>
            <div style={{ marginTop: 8 }}>
              <Button variant="secondary" size="sm" onClick={handlePrintBarcode} disabled={!selectedTests || selectedTests.length === 0}>
                Print to Thermal
              </Button>
            </div>
            <div style={{ marginTop: 10, fontSize: 12, color: "#666" }}>
              IMPORTANT: The print window sets the page width to your chosen thermal paper width (in mm). The printed result depends on your browser's print dialog and your thermal printer settings (DPI, scale). If it prints too big or small, try toggling paperWidth or adjust Bar Width / Barcode Height.
            </div>
          </div>
        </div>

      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Cancel</Button>
        <Button variant="primary" onClick={handleConfirm}>Collected</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SampleModel;

